module.exports = __webpack_public_path__ + "static/media/Shop-By-Vehicle-Icon-White.a50fe866.svg";